import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ICommonProps } from '..';

interface IContentCard extends Partial<ICommonProps> {
  cardTitle?: string;
}

export const ContentCard = ({
  cardTitle,
  children,
  className,
  id
}: IContentCard) => {
  return (
    <div className='flex flex-col gap-3 md:gap-6' id={id}>
      {cardTitle && <h1 className='font-fraunces'>{cardTitle || ''}</h1>}
      <div
        className={twMerge(
          'flex flex-col rounded-radi-md border-black bg-white p-5 shadow-box md:p-9',
          className
        )}>
        {children}
      </div>
    </div>
  );
};
